const authTabs = document.querySelectorAll('.authorization-tab'),
      authForms = document.querySelectorAll('.authorization-form');


if(authTabs && authForms) {
  authTabs[0]?.classList.add('active')
  authForms[0]?.classList.add('active')
  authTabs?.forEach((item, i) => {
    item?.addEventListener('click', () => {
      if(item?.classList.contains('active')) return
  
      authTabs?.forEach(t => t.classList.remove('active'))
      authForms?.forEach(t => t.classList.remove('active'))
  
      item?.classList.add('active')
      authForms[i]?.classList.add('active')
    })
  })
}